import { render, staticRenderFns } from "./CoachMindsetReportCard.vue?vue&type=template&id=148c3790&scoped=true&"
import script from "./CoachMindsetReportCard.vue?vue&type=script&lang=ts&"
export * from "./CoachMindsetReportCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148c3790",
  null
  
)

export default component.exports